import { faCat } from '@fortawesome/pro-light-svg-icons/faCat';
import { faDog } from '@fortawesome/pro-light-svg-icons/faDog';
import { faTurtle } from '@fortawesome/pro-light-svg-icons/faTurtle';
import { faSquare } from '@fortawesome/pro-light-svg-icons/faSquare';
import { faSquareCheck } from '@fortawesome/pro-solid-svg-icons/faSquareCheck';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PetType, PetTypeIds } from '@spike/model';
import clsx from 'clsx';
import { FunctionComponent, useState } from 'react';
import styles from './PetTypeOption.module.scss';
import useNonInitialEffect from '@versiondos/hooks';

interface PetTypeOptionProps {
    petType: PetType;
    selected: boolean;
    onChange?: (selected: boolean) => void;
    className?: string;
}

const getIcon = (petType: PetType) => {
    switch (petType.id) {
        case PetTypeIds.DOGS:
            return faDog;
        case PetTypeIds.CATS:
            return faCat;
        default:
            return faTurtle;
    }
};

export const PetTypeOption: FunctionComponent<PetTypeOptionProps> = props => {
    useNonInitialEffect(() => {
        if (props.selected !== selected) {
            setSelected(props.selected);
        }
    }, [props.selected]);

    const [selected, setSelected] = useState(props.selected);

    const clickHandler = () => {
        const updatedSelected = !selected;
        setSelected(updatedSelected);
        props.onChange?.(updatedSelected);
    };

    return (
        <div
            className={clsx(styles.container, { [styles.selectedContainer]: selected }, props.className)}
            onClick={clickHandler}
        >
            <div
                className={clsx(styles.iconContainer, {
                    [styles.dogsColor]: props.petType.id === PetTypeIds.DOGS,
                    [styles.catsColor]: props.petType.id === PetTypeIds.CATS,
                    [styles.exoticsColor]: props.petType.id === PetTypeIds.EXOTICS
                })}
            >
                <FontAwesomeIcon icon={getIcon(props.petType)} />
            </div>
            <span className={styles.label}>{props.petType.plural}</span>
            <div className={styles.checkContainer}>
                <FontAwesomeIcon
                    icon={selected ? faSquareCheck : faSquare}
                    fontSize={15}
                    color={selected ? '#000' : '#d3d3d3'}
                />
            </div>
        </div>
    );
};

export default PetTypeOption;
